module.exports = __webpack_public_path__ + "img/vehicle_car.a268fc19.png";